/* Free gift over a cart amount (2026-10-20) — config in window.vpxGift (snippets/vpx-gift-config.liquid).
   After every cart change: when the products that count (one-time purchases except the gift product itself, after
   discounts, order codes shared out pro rata — the same way the free-shipping bar counts) reach the amount, one gift
   line is added with the hidden property _vpx_gift; when they drop below it, the line is removed.
   Safety: the gift must really cost 0 (the automatic discount applied). If a discount code that can't combine with
   it is in the cart, Shopify charges full price — then the line is taken out again at once and the bar says why.
   If the shopper removes the gift themselves, it is not forced back in (a button on the bar re-adds it).
   Publishes window.vpxGiftInfo(cart) and a 'vpx:gift' event so the mini-cart and the cart page draw the bar. */
(function () {
  var C = window.vpxGift;
  if (!C || !(C.threshold > 0) || !C.variantId) return;
  var root = (C.root || '/').replace(/\/?$/, '/');
  var nativeFetch = window.fetch.bind(window);
  var MINE = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-VPX-Gift': '1' };
  var K_DECLINED = 'vpx-gift-declined', K_BLOCKED = 'vpx-gift-blocked', K_HAD = 'vpx-gift-had';
  function store(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { /* private mode: no memory, fine */ }
    return null;
  }
  function rate() { return Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; }
  function isGift(i) { return i.variant_id === C.variantId && i.properties && i.properties._vpx_gift; }
  function codes(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }).sort().join(','); }
  function counted(cart) {
    var all = 0, c = 0;
    // Subscriptions don't count: the discount is set to one-time purchases (Admin › Discounts › Purchase type).
    cart.items.forEach(function (i) { all += i.final_line_price; if (i.product_id !== C.productId && !i.selling_plan_allocation) c += i.final_line_price; });
    return all > 0 ? Math.round(c * cart.total_price / all) : 0;
  }

  // What the bars need to know about a cart.
  window.vpxGiftInfo = function (cart) {
    var goal = Math.round(C.threshold * 100 * rate());
    var have = counted(cart);
    var gift = cart.items.filter(isGift)[0];
    var won = have >= goal;
    return {
      show: cart.item_count > 0, goal: goal, have: have, won: won, inCart: !!gift,
      left: Math.max(0, goal - have), progress: Math.min(have / goal, 1),
      blocked: won && !gift && store(K_BLOCKED) === codes(cart),
      declined: won && !gift && store(K_DECLINED) === '1'
    };
  };

  function get() { return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function add() {
    return nativeFetch(root + 'cart/add.js', { method: 'POST', headers: MINE,
      body: JSON.stringify({ items: [{ id: C.variantId, quantity: 1, properties: { _vpx_gift: '1' } }] }) });
  }
  function setQty(key, qty) {
    return nativeFetch(root + 'cart/change.js', { method: 'POST', headers: MINE, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); });
  }
  // Tell the mini-cart and the cart page (Horizon re-renders on cart:update) that the cart changed.
  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true,
      detail: { resource: cart, sourceId: 'vpx-gift', data: { source: 'vpx-gift', itemCount: cart.item_count } } }));
  }
  var lastCart = null;
  function publish(cart) {
    lastCart = cart;
    paintPage();
    var info = window.vpxGiftInfo(cart); info.cart = cart;
    document.dispatchEvent(new CustomEvent('vpx:gift', { detail: info }));
  }
  // Cart page (snippets/vpx-ship-progress.liquid draws the bar in Liquid): only the "a code blocks the gift" case
  // needs the script, since Liquid can't know it. Re-applied whenever the theme re-renders the cart section.
  function paintPage() {
    var box = document.querySelector('[data-vpx-gift-page]');
    if (!box || !lastCart || !window.vpxGiftBlockedText) return;
    var g = window.vpxGiftInfo(lastCart);
    var msg = box.querySelector('[data-vpx-gift-page-msg]');
    if (g.blocked && msg && msg.getAttribute('data-blocked') !== '1') { msg.textContent = window.vpxGiftBlockedText; msg.setAttribute('data-blocked', '1'); }
  }
  if (document.querySelector('[data-vpx-gift-page]')) {
    var paintTimer = 0;
    new MutationObserver(function () { clearTimeout(paintTimer); paintTimer = setTimeout(paintPage, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }

  var busy = false, again = false, timer = 0;
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms == null ? 350 : ms); }
  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false;
    get().then(function (cart) {
      var info = window.vpxGiftInfo(cart);
      var gifts = cart.items.filter(isGift);
      if (!info.won) {
        store(K_DECLINED, null); store(K_BLOCKED, null); store(K_HAD, null);
        if (!gifts.length) return cart;
        changed = true;
        return setQty(gifts[0].key, 0);
      }
      if (gifts.length) {
        store(K_HAD, '1');
        var g = gifts[0];
        if (g.final_line_price > 0) {                     // not free: a code in the cart blocks the discount
          store(K_BLOCKED, codes(cart)); store(K_HAD, null); changed = true;
          return setQty(g.key, 0);
        }
        if (g.quantity > 1) { changed = true; return setQty(g.key, 1); }
        return cart;
      }
      // Qualifies, no gift line: the shopper removed it, a code blocks it, or it's time to add it.
      if (store(K_HAD) === '1') { store(K_DECLINED, '1'); store(K_HAD, null); }
      if (store(K_DECLINED) === '1' || store(K_BLOCKED) === codes(cart) || !C.available) return cart;
      changed = true;
      return add().then(get).then(function (c2) {
        var g2 = c2.items.filter(isGift)[0];
        if (g2 && g2.final_line_price > 0) { store(K_BLOCKED, codes(c2)); return setQty(g2.key, 0); }
        if (g2) store(K_HAD, '1');
        return c2;
      });
    }).then(function (cart) {
      return changed ? get() : cart;
    }).then(function (cart) {
      if (changed) announce(cart);
      publish(cart);
    }).catch(function () { /* network hiccup: the next cart change tries again */ })
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }

  // Re-add after the shopper removed it (button on the bar).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vpx-gift-readd]');
    if (!b) return;
    e.preventDefault();
    store(K_DECLINED, null);
    schedule(0);
  });

  // Every cart change anywhere: theme events plus any fetch to the cart API that isn't ours.
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'vpx-gift') return;
    schedule();
  });
  document.addEventListener('cart:refresh', function () { schedule(); });
  var prevFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = prevFetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && init.headers['X-VPX-Gift'];
    if (!mine && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };
  schedule(0);
})();
